import { GameParams } from "supercell-frontend-base/src/validation/game-params";
import { z } from "zod";

export const BrawlStarsGameParamsSchema = GameParams;

export type BrawlStarsGameParams = z.infer<typeof BrawlStarsGameParamsSchema>;
